// import React, { useState } from "react";
// import { Button, FormGroup, Label } from "reactstrap";
// import { Upload, Download } from "react-feather";
// import { useDispatch } from "react-redux";

// const ExcelUpload = ({ onUpload }) => {
//   const [file, setFile] = useState(null);
//   const dispatch = useDispatch();

//   // 🔹 Handle file selection
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];
//     setFile(selectedFile);
//   };

//   // 🔹 Upload Excel
//   const handleUpload = () => {
//     const formData = new FormData();
//     formData.append("file", file);

//     // send to parent / API
//     onUpload();
//   };

//   // 🔹 Download dummy Excel
//   const handleDownloadSample = () => {
//     const link = document.createElement("a");
//     link.href = "/dummy_trip_upload.xlsx"; // from public
//     link.download = "dummy_trip_upload.xlsx";
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   };

//   return (
//     <>
//       {/* Upload Section */}
//       <FormGroup>
//         <Label className="form-label">Upload Excel File</Label>
//         <input
//           type="file"
//           accept=".xls,.xlsx"
//           className="form-control"
//           onChange={handleFileChange}
//         />
//       </FormGroup>

//       <div className="d-flex gap-2 mt-2">
//         <Button color="primary" onClick={handleUpload}>
//           <Upload size={16} className="me-1" />
//           Upload Excel
//         </Button>

//         <Button color="secondary" outline onClick={handleDownloadSample}>
//           <Download size={16} className="me-1" />
//           Download Sample
//         </Button>
//       </div>
//     </>
//   );
// };

// export default ExcelUpload;

import React, { useState } from "react";
import { Button, FormGroup, Label, Spinner } from "reactstrap";
import { Upload, Download } from "react-feather";
import { useDispatch } from "react-redux";
import { uploadExcel } from "../../slices/GSTReport/thunk";
// import sampleFile from "../..//SampleFolder/Sample_customer_supplier_Master.xlsx";
import sampleFile from "../../assets/SampleFolder/Sample_customer_supplier_Master.xlsx";
import { toast } from "react-toastify";
const ExcelUpload = () => {
  const dispatch = useDispatch();

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  const handleUpload = async () => {
    if (!file) {
      // alert("Please select an Excel file");
      toast.error("Please select an Excel file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);
      await dispatch(uploadExcel(formData));
    } finally {
      setUploading(false);
    }
  };

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = sampleFile;
    link.download = "Sample_customer_supplier_Master.xlsx";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="page-content">
      <FormGroup>
        <Label className="form-label">Upload Excel File</Label>
        <input
          type="file"
          accept=".xls,.xlsx"
          className="form-control"
          onChange={handleFileChange}
          disabled={uploading}
        />
      </FormGroup>

      <div className="d-flex gap-2 mt-2">
        <Button color="primary" onClick={handleUpload} disabled={uploading}>
          {uploading ? (
            <>
              <Spinner size="sm" className="me-1" />
              Uploading...
            </>
          ) : (
            <>
              <Upload size={16} className="me-1" />
              Upload Excel
            </>
          )}
        </Button>

        <Button
          color="secondary"
          outline
          onClick={handleDownloadSample}
          disabled={uploading}
        >
          <Download size={16} className="me-1" />
          Download Sample
        </Button>
      </div>
    </div>
  );
};

export default ExcelUpload;
